// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__hzFox","options":"AnswerScale_options__3ykoJ","selected":"AnswerScale_selected__3ApQN"};